var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 96,
    fill: "none",
    viewBox: "0 0 92 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M69.957 62.565h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M68.004 62.565H56.522a.46.46 0 0 1-.463-.463v-2.604c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M64.24 62.565h-3.954a.28.28 0 0 1-.28-.279v-2.972a.28.28 0 0 1 .28-.279h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.28.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M55.033 59.465a.533.533 0 0 0-.533.532v2.465a.5.5 0 0 0 .01.1q.028.003.058.003h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M69.957 59.036h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M68.004 59.036H56.522a.46.46 0 0 1-.463-.463v-2.604c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M64.24 59.036h-3.954a.28.28 0 0 1-.28-.28v-2.971a.28.28 0 0 1 .28-.279h3.954a.28.28 0 0 1 .279.279v2.972a.28.28 0 0 1-.28.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M55.033 55.935a.533.533 0 0 0-.533.533v2.464q0 .051.01.1.028.003.058.003h15.39a.533.533 0 0 0 .533-.532v-2.464a.5.5 0 0 0-.01-.1l-.058-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M69.957 55.506h-15.39a.533.533 0 0 1-.532-.533V52.51c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M68.004 55.506H56.522a.463.463 0 0 1-.463-.462v-2.605c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.605a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M64.24 55.506h-3.954a.28.28 0 0 1-.28-.279v-2.971a.28.28 0 0 1 .28-.28h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.28.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M55.033 52.406a.533.533 0 0 0-.533.533v2.464a.5.5 0 0 0 .01.1q.028.003.058.003h15.39a.533.533 0 0 0 .533-.532v-2.465a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M69.957 51.977h-15.39a.533.533 0 0 1-.532-.533V48.98c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M68.004 51.977H56.522a.463.463 0 0 1-.463-.463V48.91c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M64.24 51.977h-3.954a.28.28 0 0 1-.28-.28v-2.97a.28.28 0 0 1 .28-.28h3.954a.28.28 0 0 1 .279.28v2.97a.28.28 0 0 1-.28.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M55.033 48.877a.533.533 0 0 0-.533.532v2.464a.5.5 0 0 0 .01.1q.028.003.058.004h15.39a.533.533 0 0 0 .533-.533V48.98a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M69.957 48.447h-15.39a.533.533 0 0 1-.532-.532V45.45c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.465a.533.533 0 0 1-.533.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M68.004 48.447H56.522a.463.463 0 0 1-.463-.462V45.38c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.605a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M64.24 48.447h-3.954a.28.28 0 0 1-.28-.279v-2.971a.28.28 0 0 1 .28-.28h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.28.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M55.033 45.347a.533.533 0 0 0-.533.533v2.464a.5.5 0 0 0 .01.1q.028.003.058.003h15.39a.533.533 0 0 0 .533-.532V45.45a.5.5 0 0 0-.01-.1l-.058-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M69.957 44.918h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M68.004 44.918H56.522a.463.463 0 0 1-.463-.463v-2.604c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M64.24 44.918h-3.954a.28.28 0 0 1-.28-.279v-2.972a.28.28 0 0 1 .28-.279h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.28.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M55.033 41.818a.533.533 0 0 0-.533.532v2.465a.5.5 0 0 0 .01.1q.028.003.058.003h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M69.957 41.389h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M68.004 41.389H56.522a.46.46 0 0 1-.463-.463v-2.604c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M64.24 41.389h-3.954a.28.28 0 0 1-.28-.28v-2.97a.28.28 0 0 1 .28-.28h3.954a.28.28 0 0 1 .279.28v2.97a.28.28 0 0 1-.28.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M55.033 38.289a.533.533 0 0 0-.533.532v2.464a.5.5 0 0 0 .01.1q.028.004.058.004h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M69.957 37.859h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M68.004 37.859H56.522a.463.463 0 0 1-.463-.462v-2.605c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.605a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M64.24 37.859h-3.954a.28.28 0 0 1-.28-.279v-2.97a.28.28 0 0 1 .28-.28h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.28.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M55.033 34.76a.533.533 0 0 0-.533.532v2.464a.5.5 0 0 0 .01.1q.028.003.058.003h15.39a.533.533 0 0 0 .533-.532v-2.465a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "m61.95 47.243-1.414-7.418a11.73 11.73 0 0 0-11.525-9.534h-5.306a11.73 11.73 0 0 0-11.524 9.534l-.802 4.206c-.77 4.04-2.002 7.994-3.844 11.673a7.34 7.34 0 0 0-.769 3.598c.153 3.751 3.455 6.98 7.209 7.053h.082c1.703.016 3.343.68 4.538 1.893a7.34 7.34 0 0 0 5.246 2.2 7.35 7.35 0 0 0 6.027-3.136 2.28 2.28 0 0 1 1.878-.956h.013q.481 0 .943-.07a2.27 2.27 0 0 1 1.647.402 7.33 7.33 0 0 0 4.628 1.337c3.696-.187 6.711-3.146 6.962-6.838a7.35 7.35 0 0 0-.703-3.694c-1.56-3.247-2.611-6.713-3.286-10.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M34.122 66.356a7.363 7.363 0 1 0 0-14.726 7.363 7.363 0 0 0 0 14.726"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M43.84 70.447a7.363 7.363 0 1 0 0-14.725 7.363 7.363 0 0 0 0 14.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M58.595 68.035a7.363 7.363 0 1 0 0-14.725 7.363 7.363 0 0 0 0 14.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M65.94 61.187a7.35 7.35 0 0 0-.704-3.694c-1.56-3.247-2.612-6.713-3.286-10.25l-1.414-7.418a11.7 11.7 0 0 0-2.502-5.298 11.7 11.7 0 0 0-7.482-2.695h-5.306a11.73 11.73 0 0 0-11.525 9.534l-.801 4.205c-.771 4.042-2.003 7.995-3.845 11.674a7.34 7.34 0 0 0-.768 3.597c.06 1.476.609 2.87 1.48 4.024 1.198.902 2.655 1.458 4.188 1.488l.082.002c1.703.014 3.343.678 4.537 1.892a7.34 7.34 0 0 0 5.246 2.199 7.35 7.35 0 0 0 6.028-3.135 2.28 2.28 0 0 1 1.878-.956h.013q.48 0 .943-.07a2.27 2.27 0 0 1 1.647.401 7.33 7.33 0 0 0 4.627 1.338c3.697-.187 6.712-3.146 6.963-6.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M50.636 38.958a10.5 10.5 0 0 0-2.22-.443l-.005-.004-1.08-1.117a1.24 1.24 0 0 0-.692-.21q-.427 0-.72.198-.294.198-.293.47v.692q-2.319.326-3.825 1.712t-1.505 3.804q0 .987.346 1.8.345.813.8 1.332l4.184 4.188v2.488q-1.04-.186-2.265-1.053-1.227-.866-1.733-.866-.72 0-1.266.747-.546.746-.546 1.492 0 .972.953 1.796l10.434 10.434q.265-.062.544-.062h.013q.48 0 .943-.07a2.27 2.27 0 0 1 1.647.402 7.33 7.33 0 0 0 4.627 1.338c3.697-.187 6.712-3.147 6.963-6.84a7.35 7.35 0 0 0-.703-3.693c-1.085-2.26-1.924-4.626-2.562-7.048L51.929 39.699q-.494-.494-1.293-.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M52.569 49.844q-.335-.853-.8-1.413-.466-.56-1.24-1.066a9.6 9.6 0 0 0-1.385-.772 49 49 0 0 0-1.493-.614v-3.89q.96.08 1.853.532.892.454 1.266.453.773 0 1.212-.758.44-.758.44-1.463 0-.66-.493-1.154-.494-.494-1.293-.74a10.5 10.5 0 0 0-1.519-.358q-.72-.11-1.466-.137v-.615q0-.246-.32-.455a1.24 1.24 0 0 0-.692-.21q-.427 0-.72.198-.294.198-.293.47v.692q-2.319.326-3.825 1.712t-1.505 3.804q0 .987.346 1.8.345.813.8 1.332.453.52 1.279 1.013t1.386.733 1.519.613v4.317q-1.04-.186-2.265-1.053-1.227-.866-1.733-.866-.72 0-1.266.747-.546.746-.546 1.492 0 1.306 1.719 2.346t4.09 1.119v.666q0 .293.294.506.292.213.72.214.373 0 .693-.227t.32-.493v-.773q2.398-.4 3.824-1.892t1.426-3.918q0-1.039-.333-1.892m-6.677-4.504q-1.705-.72-1.705-1.68 0-1.144 1.705-1.492zm1.493 8.502V50.27q1.625.773 1.626 1.893 0 1.305-1.626 1.679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M49.975 30.29h-7.233l-3.29-6.307a1.56 1.56 0 0 1 1.102-2.256l2.155-.395a20.2 20.2 0 0 1 7.3 0l2.154.395a1.56 1.56 0 0 1 1.102 2.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M47.561 30.29h-2.405l-1.094-6.307c-.162-.931.023-2.067.366-2.256l.717-.395c.802-.443 1.625-.443 2.428 0l.716.395c.344.19.528 1.325.367 2.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M53.156 22.362c.141.2.07.48-.148.59a3.6 3.6 0 0 1-3.266 0l-.907-.46a3.6 3.6 0 0 0-3.266 0l-.906.46a3.6 3.6 0 0 1-3.266 0l-.949-.482c-.332-.17-.27-.672.096-.74l.01-.003 2.155-.395a20.3 20.3 0 0 1 7.3 0l2.154.395c.426.078.77.316.993.635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M53.286 23.246q.072-.177.11-.36a1.56 1.56 0 0 0-1.233-1.16l-2.154-.394a20.2 20.2 0 0 0-7.3 0l-1.608.294a2.14 2.14 0 0 0-.005 1.62L44 30.29h5.975l1.942-3.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M46.359 30.998c-1.568 0-3.052-.101-4.268-.289a.708.708 0 0 1 .21-1.398c1.142.175 2.579.273 4.058.273s2.915-.098 4.057-.273a.708.708 0 0 1 .21 1.398c-1.216.188-2.7.289-4.267.289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M37.948 50.232a.53.53 0 0 0-.516-.408h-7.517a41 41 0 0 1-2.38 5.88 7.34 7.34 0 0 0-.769 3.597c.153 3.752 3.455 6.98 7.209 7.054h.082c1.704.015 3.343.68 4.538 1.893a7.34 7.34 0 0 0 5.246 2.199 7.35 7.35 0 0 0 6.028-3.135 2.28 2.28 0 0 1 1.877-.956h.013q.481 0 .944-.07a2.27 2.27 0 0 1 1.646.401q.083.059.168.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M37.432 71h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M35.479 71H23.995a.463.463 0 0 1-.463-.463v-2.604c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M31.714 71H27.76a.28.28 0 0 1-.279-.279V67.75c0-.153.125-.278.279-.278h3.954c.154 0 .279.124.279.278v2.972a.28.28 0 0 1-.279.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M22.507 67.9a.533.533 0 0 0-.533.532v2.465q0 .05.01.1.029.003.058.003h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M37.432 67.47h-15.39a.533.533 0 0 1-.532-.532v-2.464c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M35.479 67.47H23.995a.463.463 0 0 1-.463-.462v-2.604c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M31.714 67.47H27.76a.28.28 0 0 1-.279-.278V64.22a.28.28 0 0 1 .279-.279h3.954a.28.28 0 0 1 .279.28v2.97a.28.28 0 0 1-.279.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M22.507 64.37a.533.533 0 0 0-.533.533v2.464q0 .052.01.1.029.004.058.004h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M37.432 63.941h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M35.479 63.941H23.995a.463.463 0 0 1-.463-.462v-2.605c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.605a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M31.714 63.941H27.76a.28.28 0 0 1-.279-.279v-2.971a.28.28 0 0 1 .279-.28h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.279.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M22.507 60.841a.533.533 0 0 0-.533.533v2.464q0 .051.01.1.029.003.058.003h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M37.432 60.412h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M35.479 60.412H23.995a.463.463 0 0 1-.463-.463v-2.604c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M31.714 60.412H27.76a.28.28 0 0 1-.279-.28v-2.97a.28.28 0 0 1 .279-.28h3.954a.28.28 0 0 1 .279.28v2.97a.28.28 0 0 1-.279.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M22.507 57.312a.533.533 0 0 0-.533.532v2.464q0 .052.01.1.029.004.058.004h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M37.432 56.882h-15.39a.533.533 0 0 1-.532-.532v-2.464c0-.294.238-.533.532-.533h15.39c.294 0 .533.239.533.533v2.464a.533.533 0 0 1-.533.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M35.479 56.882H23.995a.46.46 0 0 1-.463-.462v-2.604c0-.256.207-.463.463-.463h11.482c.256 0 .463.207.463.463v2.604a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M31.714 56.882H27.76a.28.28 0 0 1-.279-.279v-2.971a.28.28 0 0 1 .279-.279h3.954a.28.28 0 0 1 .279.279v2.971a.28.28 0 0 1-.279.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M22.507 53.783a.533.533 0 0 0-.533.532v2.464q0 .052.01.1l.058.004h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M37.432 53.353h-15.39a.533.533 0 0 1-.532-.533v-2.464c0-.294.238-.532.532-.532h15.39c.294 0 .533.238.533.532v2.464a.533.533 0 0 1-.533.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M35.479 53.353H23.995a.46.46 0 0 1-.463-.462v-2.605c0-.255.207-.462.463-.462h11.482c.256 0 .463.207.463.462v2.605a.46.46 0 0 1-.463.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M31.714 53.353H27.76a.28.28 0 0 1-.279-.279v-2.971a.28.28 0 0 1 .279-.28h3.954a.28.28 0 0 1 .279.28v2.971a.28.28 0 0 1-.279.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M22.507 50.253a.533.533 0 0 0-.533.533v2.464q0 .05.01.1l.058.003h15.39a.533.533 0 0 0 .533-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M66.29 71H50.9a.533.533 0 0 1-.533-.533v-2.464c0-.294.239-.532.533-.532h15.39c.294 0 .532.238.532.532v2.464a.533.533 0 0 1-.532.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M64.336 71H52.853a.463.463 0 0 1-.462-.463v-2.604c0-.255.207-.462.462-.462h11.483c.255 0 .463.207.463.462v2.604a.463.463 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M60.571 71h-3.954a.28.28 0 0 1-.279-.279V67.75a.28.28 0 0 1 .28-.278h3.953a.28.28 0 0 1 .28.278v2.972a.28.28 0 0 1-.28.279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M51.364 67.9a.533.533 0 0 0-.532.532v2.465q0 .05.01.1.028.003.058.003h15.39a.533.533 0 0 0 .532-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M66.29 67.47H50.9a.533.533 0 0 1-.533-.532v-2.464c0-.294.239-.533.533-.533h15.39c.294 0 .532.239.532.533v2.464a.533.533 0 0 1-.532.533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M64.336 67.47H52.853a.463.463 0 0 1-.462-.462v-2.604c0-.256.207-.463.462-.463h11.483c.255 0 .463.207.463.463v2.604a.463.463 0 0 1-.463.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M60.571 67.47h-3.954a.28.28 0 0 1-.279-.278V64.22a.28.28 0 0 1 .28-.279h3.953a.28.28 0 0 1 .28.28v2.97a.28.28 0 0 1-.28.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M51.364 64.37a.533.533 0 0 0-.532.533v2.464q0 .052.01.1.028.004.058.004h15.39a.533.533 0 0 0 .532-.533v-2.464a.5.5 0 0 0-.01-.1l-.058-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M30.123 41.557a12.5 12.5 0 0 0-3.679 3.7.55.55 0 0 1-.92-.001 12.5 12.5 0 0 0-3.665-3.714.55.55 0 0 1 .001-.914 12.5 12.5 0 0 0 3.68-3.7.55.55 0 0 1 .92 0 12.5 12.5 0 0 0 3.665 3.715c.326.214.325.7-.002.914"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M35.987 28.205a8.8 8.8 0 0 0-2.602 2.617.388.388 0 0 1-.65-.001 8.8 8.8 0 0 0-2.593-2.626.388.388 0 0 1 .001-.647 8.8 8.8 0 0 0 2.602-2.617.388.388 0 0 1 .65.001 8.8 8.8 0 0 0 2.593 2.627c.23.151.23.495-.002.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M64.258 30.62a8.8 8.8 0 0 0-2.601 2.616.388.388 0 0 1-.651-.001 8.8 8.8 0 0 0-2.592-2.626.388.388 0 0 1 0-.647 8.8 8.8 0 0 0 2.602-2.617.388.388 0 0 1 .651.001 8.8 8.8 0 0 0 2.592 2.627c.23.151.23.495-.001.646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 62.262,
    x2: 62.262,
    y1: 59.108,
    y2: 63.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 62.263,
    x2: 62.263,
    y1: 59.175,
    y2: 66.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 62.263,
    x2: 62.263,
    y1: 59.175,
    y2: 66.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 62.244,
    x2: 60.419,
    y1: 60.407,
    y2: 55.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 62.262,
    x2: 62.262,
    y1: 55.579,
    y2: 60.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 62.263,
    x2: 62.263,
    y1: 55.645,
    y2: 63.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 62.263,
    x2: 62.263,
    y1: 55.645,
    y2: 63.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 62.244,
    x2: 60.419,
    y1: 56.878,
    y2: 52.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 62.262,
    x2: 62.262,
    y1: 52.049,
    y2: 56.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 62.263,
    x2: 62.263,
    y1: 52.116,
    y2: 59.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 62.263,
    x2: 62.263,
    y1: 52.116,
    y2: 59.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 62.244,
    x2: 60.419,
    y1: 53.349,
    y2: 48.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 62.262,
    x2: 62.262,
    y1: 48.52,
    y2: 53.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 62.263,
    x2: 62.263,
    y1: 48.586,
    y2: 56.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 62.263,
    x2: 62.263,
    y1: 48.586,
    y2: 56.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 62.244,
    x2: 60.419,
    y1: 49.819,
    y2: 45.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 62.262,
    x2: 62.262,
    y1: 44.991,
    y2: 49.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 62.263,
    x2: 62.263,
    y1: 45.057,
    y2: 52.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 62.263,
    x2: 62.263,
    y1: 45.057,
    y2: 52.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 62.244,
    x2: 60.419,
    y1: 46.29,
    y2: 41.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 62.262,
    x2: 62.262,
    y1: 41.461,
    y2: 46.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 62.263,
    x2: 62.263,
    y1: 41.528,
    y2: 49.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 62.263,
    x2: 62.263,
    y1: 41.528,
    y2: 49.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 62.244,
    x2: 60.419,
    y1: 42.76,
    y2: 38.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 62.262,
    x2: 62.262,
    y1: 37.932,
    y2: 42.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 62.263,
    x2: 62.263,
    y1: 37.998,
    y2: 45.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 62.263,
    x2: 62.263,
    y1: 37.998,
    y2: 45.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 62.244,
    x2: 60.419,
    y1: 39.231,
    y2: 34.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 62.262,
    x2: 62.262,
    y1: 34.402,
    y2: 38.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 62.263,
    x2: 62.263,
    y1: 34.469,
    y2: 42.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 62.263,
    x2: 62.263,
    y1: 34.469,
    y2: 42.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3C3DE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#3541CC",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 62.244,
    x2: 60.419,
    y1: 35.702,
    y2: 31.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 34.199,
    x2: 33.139,
    y1: 56.609,
    y2: 89.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 43.85,
    x2: 48.563,
    y1: 63.12,
    y2: 81.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 58.431,
    x2: 56.703,
    y1: 62.767,
    y2: 84.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 44.059,
    x2: 21.91,
    y1: 49.833,
    y2: 10.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 59.51,
    x2: 31.443,
    y1: 57.499,
    y2: 41.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 43.142,
    x2: 58.516,
    y1: 45.074,
    y2: 58.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FDBF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#F7A848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#ED835B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 44.585,
    x2: 49.768,
    y1: 19.512,
    y2: 30.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#47B071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3FA870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#1C8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 46.287,
    x2: 53.278,
    y1: 25.296,
    y2: 36.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 46.63,
    x2: 46.983,
    y1: 21.366,
    y2: 24.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 45.096,
    x2: 31.725,
    y1: 25.642,
    y2: 25.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91F27F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 46.359,
    x2: 46.359,
    y1: 29.594,
    y2: 31.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FDBF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#F7A848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#ED835B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 45.066,
    x2: 34.698,
    y1: 60.517,
    y2: 59.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005A01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 29.737,
    x2: 29.737,
    y1: 67.543,
    y2: 72.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 29.737,
    x2: 29.737,
    y1: 67.61,
    y2: 75.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 29.737,
    x2: 29.737,
    y1: 67.61,
    y2: 75.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 29.718,
    x2: 27.894,
    y1: 68.843,
    y2: 64.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 29.737,
    x2: 29.737,
    y1: 64.014,
    y2: 68.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 29.737,
    x2: 29.737,
    y1: 64.08,
    y2: 71.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 29.737,
    x2: 29.737,
    y1: 64.08,
    y2: 71.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 29.718,
    x2: 27.894,
    y1: 65.313,
    y2: 60.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 29.737,
    x2: 29.737,
    y1: 60.484,
    y2: 65.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 29.737,
    x2: 29.737,
    y1: 60.551,
    y2: 68.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 29.737,
    x2: 29.737,
    y1: 60.551,
    y2: 68.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 29.718,
    x2: 27.894,
    y1: 61.784,
    y2: 57.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 29.737,
    x2: 29.737,
    y1: 56.955,
    y2: 61.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 29.737,
    x2: 29.737,
    y1: 57.021,
    y2: 64.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 29.737,
    x2: 29.737,
    y1: 57.022,
    y2: 64.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 29.718,
    x2: 27.894,
    y1: 58.254,
    y2: 53.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 29.737,
    x2: 29.737,
    y1: 53.426,
    y2: 58.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 29.737,
    x2: 29.737,
    y1: 53.492,
    y2: 61.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 29.737,
    x2: 29.737,
    y1: 53.492,
    y2: 61.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 29.718,
    x2: 27.894,
    y1: 54.725,
    y2: 50.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 29.737,
    x2: 29.737,
    y1: 49.896,
    y2: 54.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 29.737,
    x2: 29.737,
    y1: 49.963,
    y2: 57.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 29.737,
    x2: 29.737,
    y1: 49.963,
    y2: 57.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 29.718,
    x2: 27.894,
    y1: 51.196,
    y2: 46.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 58.595,
    x2: 58.595,
    y1: 67.543,
    y2: 72.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 58.594,
    x2: 58.594,
    y1: 67.61,
    y2: 75.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 58.594,
    x2: 58.594,
    y1: 67.61,
    y2: 75.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 58.576,
    x2: 56.751,
    y1: 68.843,
    y2: 64.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 58.595,
    x2: 58.595,
    y1: 64.014,
    y2: 68.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 58.594,
    x2: 58.594,
    y1: 64.08,
    y2: 71.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 58.594,
    x2: 58.594,
    y1: 64.08,
    y2: 71.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 58.576,
    x2: 56.751,
    y1: 65.313,
    y2: 60.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 24.561,
    x2: 29.192,
    y1: 39.183,
    y2: 45.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 32.055,
    x2: 35.33,
    y1: 26.528,
    y2: 30.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 60.326,
    x2: 63.601,
    y1: 28.948,
    y2: 33.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(40.468 41.297)scale(33.0958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#47B071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3FA870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#1C8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 21h50v50H21z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 92,
    height: 96,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.274167 0 0 0 0 0.30731 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_9",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon1);
export default __webpack_public_path__ + "static/media/insta_icon1.d76df8da640ebd34e1a3169aaaf9281e.svg";
export { ForwardRef as ReactComponent };